import React from 'react';

export const UserContext = React.createContext({
  user: undefined,
  club: undefined,
  login: undefined,
  logout: undefined,
  register: undefined,
  errors: {},
});
